import { chordFor, hits, type Style } from '../style';

/** Amapiano: log drum bassline, soft kick, shaker 16ths, jazzy piano chords. */
const CHORDS = [[65, 69, 72, 76], [64, 67, 71, 74], [62, 65, 69, 72], [60, 64, 67, 71]]; // Fmaj7 Em7 Dm7 Cmaj7
const LOG = 'x..x..x...x...x.';

export const AMAPIANO: Style = {
  bpm: 113,
  swing: 0.1,
  play(kit, step, bar, t, len, energy) {
    const chord = chordFor(CHORDS, bar);
    if (hits('x.......x.......', step)) kit.kick(t, 0.6);
    if (hits('............x...', step)) kit.clap(t, 0.5);
    kit.shaker(t, step % 2 === 0 ? 0.9 : 0.5);
    if (hits(LOG, step)) kit.logDrum(t, (chord[step % 4] ?? 65) - 24);
    if (step === 0 || (energy > 0.5 && step === 10)) kit.keys(t, chord, len * 6, 0.8);
  },
};
